import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../../../../@casino/ui/tableKyc';
import DialogAccept from '../../components/dialog-success';
import DialogCancel from '../../components/dialog-cancel';
import {setGetKyc} from '../../store/thunk/setGetKyc';
import {setPostKyc} from '../../store/thunk/setPostKyc';
import {useStyles, columns, getRows} from './helpers';
import Title from '../../../../../@casino/ui/title';

const Kyc = () => {
    const dispatch = useDispatch();
    const classes  = useStyles();

    const [openModal, setOpenModal] = React.useState(false);
    const [openModalCancel, setOpenModalCancel] = React.useState(false);
    const [id, setId] = React.useState(0);
    const [order, setOrder] = React.useState('id');
    const [desc, setDesc] = React.useState(false);
    const [search, setSearch] = React.useState('');
    
    React.useEffect(() => {
        dispatch(setGetKyc({
            page: 1,
            rowsPerPage: 10,
            order: 'id',
            desc: false,
            search: ''
        }));
    }, [search])

    
    const kyc = useSelector(state => state.kyc.list); 
   
    const rows = React.useMemo(() => getRows(kyc.data), [kyc])
    
    return (
        <div className={classes.root}>
            <Title label="Верификация пользователей" />
            <div className={classes.wrap}>
                <input 
                    type="text"
                    placeholder="Поиск"
                    className={classes.search}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGetKyc({
                            page: 1,
                            rowsPerPage: 10,
                            order: 'id',
                            desc: true,
                            search: v.target.value
                        }));
                        setSearch(v.target.value);
                    }}
                />
            </div>
            <div className={classes.wrapBlock}>
                <TableCasino
                    order={(v) => {
                        dispatch(setGetKyc({
                            page: 1,
                            rowsPerPage: 10,
                            order: v.id,
                            desc: !desc
                        }));
                        setDesc(!desc);
                        setOrder(v.id);
                    }}
                    accept={(id) => {
                        setOpenModal(true);
                        setId(id);
                    }}
                    cancel={(id) => {
                        setOpenModalCancel(true);
                        setId(id);
                    }}
                    pagination
                    allPage={kyc.countPage}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetKyc({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetKyc({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        order,
                        desc
                    }))}
                />
            </div>
            <DialogAccept 
                setOpenModal={setOpenModal} 
                openModal={openModal} 
                submit={(val) => {
                    const temp = {
                        type: val.type,
                        id,
                        description: ''
                    }
                    dispatch(setPostKyc(temp));
                    setOpenModal(false)
                }} />
            <DialogCancel
                setOpenModal={setOpenModalCancel} 
                openModal={openModalCancel} 
                submit={(val) => {
                    const temp = {
                        type: val.type,
                        id,
                        description: val.description
                    }

                    dispatch(setPostKyc(temp));
                    setOpenModalCancel(false)
                }} />
        </div>
        
    )
}

export default Kyc;